import makeStyles from '@mui/styles/makeStyles';
import { grey, isDark } from 'global/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    margin: '0 auto',
    maxWidth: theme.breakpoints.values.lg,
    padding: theme.spacing(4),
    '& a': {
      color: theme.colors.blue
    }
  },
  tierBox: {
    margin: `${theme.spacing(3)} 0`
  }
}));
